bq.responsiveTools = {
    configDefault: {
        navOpen: true,
        exclude: ['buyerquest-checkoutlite-summary-index', 'buyerquest-checkoutlite-steps-index', 'buyerquest-checkoutlite-payment-index'],
        mq: 'xl'
    },
    config: {
        disabled: false
    },
    currentNav: 'small',
    body: $('body'),
    html: $('html'),

    init: function() {
      if(!bq.config.responsive) {
          bq.config.responsive = {};
      }

      this.config = $.extend(this.configDefault, bq.config.responsive);

      if(this.config.navOpen && this.config.exclude.length >= 1) {
        var excludes = this.config.exclude.join('|');
        if(this.body.attr('class').match(new RegExp(excludes,'g'))) {
            this.config.navOpen = false;
            var $backBtn = $.tmpl('backBtn');
            localStorage.setItem('backUrl', document.referrer);
            $('.menu-toggle-container').html($backBtn).css('visibility', 'visible');
            $backBtn.on('click', function(evt){
                var backUrl = localStorage.getItem('backUrl');
                if(backUrl && backUrl !== document.location.href) {
                    setTimeout(function(){
                        localStorage.setItem('backUrl', '');
                        document.location.href = backUrl;
                    }, 300);
                    evt.preventDefault();
                    return false;
                } else {
                  window.history.back();
                }
            });
        } else {
            localStorage.setItem('backUrl', '');
        }
      }

      if(this.html.hasClass('ipad')) {
          this.body.removeClass('responsive-tools-large-menu');
          bq.responsiveTools.config.disabled = true;
          this.currentNav = 'small';
      }

      if(this.body.hasClass('responsive-tools-large-menu')) {
        this.currentNav = 'large';
      }

      this._setEvents();

    },

    initBackBtnReplace: function(){
        if(this.body.hasClass('buyerquest-gooddata-dashboard-index')) {
            var $backBtn = $.tmpl('backBtn');
            $('.menu-toggle-container').html($backBtn);
            $backBtn.on('click', function(){
              if ($backBtn.data('target')) {
                window.location = $backBtn.data('target');
              } else {
                window.history.back();
              }
            });
        }
    },

    evaluateEvent: function() {
      if(bq.responsiveTools.config.disabled) {
        return false;
      }
      bq.responsiveTools.evaluate();
    },

    evaluate: function() {
        var isLarge = bq.helper.mq.is(this.config.mq);

        if(this._shouldRun('navOpen')) {
            if(isLarge && this.currentNav === 'small') {
                //turn into big nav
                this._enableLargeScreenMenu();
                this.currentNav = 'large';
            } else if(!isLarge && this.currentNav === 'large') {
              //turn into small nav
              this.currentNav = 'small';
              this._disableLargeScreenMenu();
            }
        }
    },

    _shouldRun: function(type) {

        if(!type) { return false; }
        if(type === 'navOpen' && !this.config.navOpen) { return false; }
        return true;
    },

    _setEvents: function() {
        var resize = false;

        if(this._shouldRun('navOpen')) {
            $(window).on('resize', {this: this}, this._catchResizeEvent);
            resize = true;
        }
    },

    _enableLargeScreenMenu: function() {
        this.body.addClass('responsive-tools-large-menu');
    },

    _disableLargeScreenMenu: function() {
        this.body.removeClass('responsive-tools-large-menu');
    },

    _catchResizeEvent: function(e) {
        var $this = e.data.this;
        return bq.helper.debounce($this.evaluateEvent(), 300);
    }

};

bq.responsiveTools.init();
bq.responsiveTools.initBackBtnReplace();

bq.init.push(bq.responsiveTools.evaluateEvent);
